import {EXIT_URL} from "../../config/app";
import UserPersistence from "../../persistence/UserPersistence";

export function ExitOut() {
  if (process.env.NODE_ENV !== 'development') {
    if(window != top){
      parent.postMessage({
        isExit: true,
      }, '*');
    } else {
      UserPersistence.clear();
      window.location.href = EXIT_URL();
    }
  } else {//localhost
    // UserPersistence.clear();
  }
}



// WEBPACK FOOTER //
// ./src/libs/comFun/exitOut.js